<section class="add-info surface-card" [class.is-collapsed]="collapsed">
  <header class="add-info__head">
    <button type="button" class="add-info__toggle" (click)="toggleCollapsed()" [attr.aria-expanded]="!collapsed">
      <span class="add-info__caret" [class.is-open]="!collapsed">▸</span>
      <span class="add-info__title experimental-marker" [title]="'audiences.extractions.experimentalHint' | translate">
        {{ 'audiences.additionalInfo.title' | translate }}
      </span>
    </button>
  </header>

  <div class="add-info__body" *ngIf="!collapsed">
    <nav class="add-info__tabs" role="tablist">
      <button type="button" class="add-info__tab" *ngFor="let tab of tabs"
              role="tab" [attr.aria-selected]="activeTab === tab"
              [class.is-active]="activeTab === tab" (click)="selectTab(tab)">
        {{ 'audiences.additionalInfo.tabs.' + tab | translate }}
      </button>
    </nav>

    <div class="add-info__panel">
      <div [hidden]="activeTab !== 'details'" *ngIf="isVisited('details')">
        <app-audience-details-tab [audience]="audience" [ownerLabel]="ownerLabel"></app-audience-details-tab>
      </div>
      <div [hidden]="activeTab !== 'volumes'" *ngIf="isVisited('volumes')">
        <app-audience-volumes-tab [audienceId]="audienceId"></app-audience-volumes-tab>
      </div>
      <div [hidden]="activeTab !== 'sociodemo'" *ngIf="isVisited('sociodemo')">
        <app-audience-sociodemo-tab [audienceId]="audienceId"></app-audience-sociodemo-tab>
      </div>
      <div [hidden]="activeTab !== 'tags'" *ngIf="isVisited('tags')">
        <app-audience-tags-tab [audienceId]="audienceId"></app-audience-tags-tab>
      </div>
      <div [hidden]="activeTab !== 'changelog'" *ngIf="isVisited('changelog')">
        <app-audience-changelog-tab [audienceId]="audienceId"></app-audience-changelog-tab>
      </div>
    </div>
  </div>
</section>
